import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #8bd2f5;\n      }\n\n      .st1 {\n        fill: #8cd2f5;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			id: "arrow",
			className: "st0",
			d: "M4.7,1.6v-.8c0-.3.3-.6.6-.6,0,0,0,0,0,0h7c.3,0,.6.3.6.6,0,0,0,0,0,0v7c0,.3-.3.6-.6.6,0,0,0,0,0,0h-.8c-.3,0-.6-.3-.6-.6,0,0,0,0,0,0V3.6c.1,0-5.1,5.2-5.1,5.2-.2.2-.6.2-.9,0,0,0,0,0,0,0l-.6-.6c-.2-.2-.2-.6,0-.9,0,0,0,0,0,0l5.2-5.2h-4.2c-.3.1-.6-.2-.6-.5,0,0,0,0,0,0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M8.1,7.9v2.1c0,.7-.6,1.2-1.2,1.2H2.9c-.7,0-1.2-.6-1.2-1.2v-4c0-.7.6-1.2,1.2-1.2h2.7l1.5-1.5s0,0-.1,0H2.9c-1.5,0-2.7,1.2-2.8,2.8v4c0,1.5,1.2,2.7,2.8,2.8h4c1.5,0,2.7-1.2,2.8-2.8v-3.6l-1.5,1.5Z"
		})
	]
});
export default SvgExternalLink;
